import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "services/api";
import { AuthUser } from "services/authService";

export interface ProfileUpdateRequest {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string | null;
  city?: string | null;
  country?: string | null;
  language?: string | null;
}

interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

interface ProfileResponse {
  success: boolean;
  user: AuthUser;
  message?: string;
}

interface ChangePasswordResponse {
  success: boolean;
  message: string;
  userId: number;
}

export function useMyProfile() {
  return useQuery({
    queryKey: ["myProfile"],
    queryFn: async (): Promise<AuthUser> => {
      const response = await api.get<ProfileResponse>("dpp/user/me");
      return response.data.user;
    },
  });
}

export function useUpdateMyProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      data: ProfileUpdateRequest,
    ): Promise<ProfileResponse> => {
      const response = await api.patch<ProfileResponse>("dpp/user/me", data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["myProfile"] });
    },
  });
}

export function useChangeMyPassword() {
  return useMutation({
    mutationFn: async (
      data: ChangePasswordRequest,
    ): Promise<ChangePasswordResponse> => {
      const response = await api.post<ChangePasswordResponse>(
        "dpp/user/me/change-password",
        data,
      );
      return response.data;
    },
  });
}
